var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ConsumerInfoResolver } from "./ConsumerInfoResolver";
import { ConsumerInfoFields } from "./models/ConsumerInfoField.model";
var getLocaleCallingCode = function (locale) {
    switch (locale) {
        case "en_GB":
            return "44";
        case "sv_SE":
            return "46";
        case "pl_PL":
            return "48";
        default:
            return undefined;
    }
};
var toDraftValue = function (value) { return ({
    firstName: value.firstName,
    lastName: value.lastName,
    emailAddress: value.emailAddress,
    mobileNumber: __assign({}, value.mobileNumber),
    countryCode: value.countryCode,
}); };
var fieldChanged = function (field, currentValue, candidate) {
    if (field === ConsumerInfoFields.MOBILE_NUMBER) {
        return (currentValue.mobileNumber.countryCode !== candidate.mobileNumber.countryCode ||
            currentValue.mobileNumber.phoneNumber !== candidate.mobileNumber.phoneNumber);
    }
    return currentValue[field] !== candidate[field];
};
var ConsumerInfoDraftController = /** @class */ (function () {
    function ConsumerInfoDraftController(initialConsumer, locale) {
        this.editedFields = [];
        this.initialConsumer = initialConsumer;
        var resolvedInitialValue = ConsumerInfoResolver.resolve(initialConsumer);
        if (!resolvedInitialValue.mobileNumber.countryCode) {
            resolvedInitialValue.mobileNumber.countryCode = getLocaleCallingCode(locale) || "";
        }
        this.acceptedValue = toDraftValue(resolvedInitialValue);
    }
    ConsumerInfoDraftController.prototype.accept = function (candidate) {
        var _this = this;
        var newlyEditedFields = Object.values(ConsumerInfoFields).filter(function (field) {
            return fieldChanged(field, _this.acceptedValue, candidate);
        });
        this.editedFields = this.editedFields
            .concat(newlyEditedFields)
            .filter(function (field, index, fields) { return fields.indexOf(field) === index; });
        var resolvedValue = ConsumerInfoResolver.resolve(this.initialConsumer, {
            value: candidate,
            editedFields: this.editedFields,
        });
        this.acceptedValue = toDraftValue(resolvedValue);
        return this.snapshot();
    };
    ConsumerInfoDraftController.prototype.snapshot = function () {
        var resolvedValue = ConsumerInfoResolver.resolve(this.initialConsumer, {
            value: this.acceptedValue,
            editedFields: this.editedFields,
        });
        return {
            value: toDraftValue(resolvedValue),
            editedFields: __spreadArray([], this.editedFields, true),
            resolvedValue: resolvedValue,
        };
    };
    return ConsumerInfoDraftController;
}());
export { ConsumerInfoDraftController };
